import dayjs from 'dayjs'
import weekOfYear from 'dayjs/plugin/weekOfYear'

dayjs.extend(weekOfYear)

// https://github.com/iamkun/dayjs/blob/master/docs/en/API-reference.md
export const DateTime = dayjs

export const mysqlDateFormat = (d) => {
  return normalizeDate(d, 'YYYY-MM-DD HH:mm:ss')
}
export const normalizeDate = (d, format) => {
  const dt = d === null || d === undefined ? dayjs() : dayjs(d)
  if (dt.isValid()) {
    switch (format) {
      case 'iso':
        return dt.format()
      case 'mysql':
        return mysqlDateFormat(d)
      case 'js':
      case 'javascript':
        return dt.toDate()
      case 0:
      case null:
      case undefined:
        return dt
    }
    try {
      const formatted = dt.format(format)
      return formatted
    } catch (e) {
      // // console.log('could not format!', format)
      return dt
    }
  }
}

export const scopeToDay = (dayScope, dateTime, format = null) => {
  const d = normalizeDate(dayScope)
  const dt = normalizeDate(dateTime)
  const scopedDt = dt.clone()
    .set('month', d.month())
    .set('year', d.year())
    .set('date', d.date())
  return normalizeDate(scopedDt, format)
}

export const dateArray = (d1, d2) => {
  d1 = normalizeDate(d1)
  d2 = normalizeDate(d2)
  let arr = []
  if (d1 && d2) {
    while (d1.isBefore(d2)) {
      arr.push(d1)
      d1 = d1.add(1, 'day')
    }
  }
  return arr
}
export const moveWeek = (d, num = 1, firstDayOfWeek = false) => {
  const current = dayjs(d)
  return getWeekArray(current.startOf('week').add(num, 'week'), firstDayOfWeek)
  // return getWeekArray(current.add(num, 'week'), firstDayOfWeek)
}

export const moveDay = (d, num = 1, format) => {
  return normalizeDate(dayjs(d).add(num, 'day'), format)
}

export const getWeekArray = (anyDate, firstDayOfWeek = false) => {
  // // console.log('anyDate', anyDate)
  const now = dayjs()
  const dt = anyDate ? dayjs(anyDate) : now.clone()
  let weekStartDate = null
  let weekStartEnd = null
  if (firstDayOfWeek) {
    // let subtractNum = firstDayMath(firstDayOfWeek)
    // // // console.log('subtractNum', subtractNum)
    // // // console.log('getWeekArray - firstDayOfWeek', firstDayOfWeek)
    // weekStartDate = dt.startOf('week').add(subtractNum, 'day')
    weekStartDate = dt.startOf('week').add(firstDayOfWeek, 'day')
    weekStartEnd = weekStartDate.endOf('week').add(6, 'day')
  } else {
    // ALWAYS start on Monday as that is how PHP and everything else understands when a new week starts
    weekStartDate = dt.startOf('week').add(1, 'day')
    weekStartEnd = weekStartDate.endOf('week').add(6, 'day')
    // weekStartEnd = weekStartDate.endOf('week').add(1, 'day')
  }
  // // console.log('getWeekArray - weekStartDate', weekStartDate, 'getWeekArray - weekStartEnd', weekStartEnd, 'getWeekArray - firstDayOfWeek', firstDayOfWeek)
  return dateArray(weekStartDate, weekStartEnd)
}

export const getWeekInfo = (anyDate, firstDayOfWeek = false) => {
  const now = dayjs()
  const dt = anyDate ? dayjs(anyDate) : now
  // let weekStartDate = dt.startOf('week')
  let weekStartDate = null
  if (firstDayOfWeek) {
    // let subtractNum = firstDayMath(firstDayOfWeek)
    // // // console.log('subtractNum', subtractNum)
    // // console.log('getWeekInfo - firstDayOfWeek', firstDayOfWeek)
    // weekStartDate = dt.startOf('week').subtract(subtractNum, 'day')
    weekStartDate = dt.startOf('week').add(firstDayOfWeek, 'day')
  } else {
    // ALWAYS start on Monday as that is how PHP and everything else understands when a new week starts
    weekStartDate = dt.startOf('week').add(1, 'day')
  }
  // // console.log('getWeekInfo - weekStartDate', weekStartDate, 'getWeekInfo - firstDayOfWeek', firstDayOfWeek)
  if (anyDate === null && (now.isAfter(weekStartDate))) {
    // weekStartDate = weekStartDate.plus({days: 7})
    weekStartDate = weekStartDate.add(1, 'week').startOf('week')
  }
  const obj = weekStartDate.toObject()
  return {
    year: obj.years,
    month: obj.months,
    day: obj.date,
    week: getWeekNumber(weekStartDate)
  }
}

export const getWeekNumber = (date) => {
  // dayjs('06/27/2018').week() // 26
  let d = normalizeDate(date)
  return d.week()
}

export const soonestOrderDate = (businessDays = 0, fromDate) => {
  let dt = fromDate ? dayjs(fromDate) : dayjs().startOf('day')
  let daysToAdd = 2
  while (businessDays > 0) {
    switch (dt.day()) {
      case 0:
      case 6:
        break // sunday & saturday
      default:
        businessDays--
    }
    dt = dt.subtract(1, 'day')
    daysToAdd++
  }
  const retDate = fromDate ? dayjs(fromDate) : dayjs().startOf('day')
  return retDate.add(daysToAdd, 'day')
}

export const nextWeekMonday = () => {
  const now = dayjs().startOf('day')
  let fromDate = dayjs().startOf('week')
  fromDate = fromDate.add(1, 'day').startOf('day') // monday
  // -- if we are in the same week scope
  if (!fromDate.isAfter(now)) {
    fromDate = fromDate.add(1, 'week')
  }
  return fromDate
}

export const lockoutDate = (daysToBlock = 0, fromDate = null) => {
  // -- find next plausible order date (aka next monday)
  if (!fromDate) {
    fromDate = nextWeekMonday()
  } else {
    fromDate = fromDate ? dayjs(fromDate) : dayjs()
  }
  let nextWeekOrderDate = fromDate.subtract(1, 'day').set('hour', 6)
  // // console.log('Next Order Date (before days blocked): ', fromDate.format('MMM DD'))
  // -- 6:00 AM next monday
  while (daysToBlock >= 0) {
    switch (nextWeekOrderDate.day()) {
      case 0:
      case 6:
        break // sunday & saturday
      default:
        daysToBlock--
        break
    }
    nextWeekOrderDate = nextWeekOrderDate.subtract(1, 'day')
  }
  return nextWeekOrderDate
}

export const minDeliveryDate = (daysToBlock = 2) => {
  let dt = dayjs()
  if (dt.day() === 5) { // if today is Friday add 2 since the weekend doesn't count
    daysToBlock = daysToBlock + 2
  }
  let nextOrderDate = dt.add(daysToBlock, 'day')
  // let dt = dayjs().add(daysToBlock, 'day')
  if (nextOrderDate.day() === 0) { // Sunday - Move to Monday
    return nextOrderDate.add(1, 'day')
  }
  if (nextOrderDate.day() === 6) { // Saturday - Move to Monday
    return nextOrderDate.add(2, 'day')
  }
  return nextOrderDate
}

export const getMinDeliveryBusinessDay = (d) => {
  let dt = dayjs(d).subtract(1, 'week')
  if (dt.day() === 5) { // if last weeks day is Saturday add 2
    return dt.add(2, 'day')
  }
  if (dt.day() === 6) { // if last weeks day is Saturday add 2
    return dt.add(1, 'day')
  }
  return dt
}

export const canOrderFromDate = (daysToBlock, selectedDay) => {
  // // console.log('-----------canOrderFromDate------------')
  const now = dayjs()
  const dt = dayjs(selectedDay)
  // -- 6:00 AM on Monday
  const testDateWeekStart = dt.startOf('week').set('hour', 6).set('minute', 0).set('second', 0)
  const soonestDate = lockoutDate(daysToBlock, testDateWeekStart)
  // // console.log('soonestDate', soonestDate)
  const days = soonestDate.diff(now, 'day')
  return {
    mustOrderBy: soonestDate,
    locked: days < 0,
    days
  }
}

export const firstDayMath = (dayNum) => {
  // Naturally the week is 0 - 6 / Sun - Sat
  // 6 = -1
  // 5 = -2
  // 4 = -3
  // 3 = -2
  // 2 = -1
  // 1 = 0
  let num = 0
  switch (dayNum) {
    case 0:
      num = -7
      break
    case 1:
      num = 1
      break
    case 2:
      num = -5
      break
    case 3:
      num = -4
      break
    case 4:
      num = -3
      break
    case 5:
      num = -2
      break
    case 6:
      num = -1
      break
    case 7:
      num = 0
      break
    default:
      num = 0
  }
  return num
}
